var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _vm.persona
        ? [
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.nombre"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.nombre,
                    callback: function ($$v) {
                      _vm.$set(_vm.solicitud.solicitante, "nombre", $$v)
                    },
                    expression: "solicitud.solicitante.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t(
                    "apeironGwApp.datosGenerales.label.primerApellido"
                  ),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.apellidoPaterno,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.solicitante,
                        "apellidoPaterno",
                        $$v
                      )
                    },
                    expression: "solicitud.solicitante.apellidoPaterno",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t(
                    "apeironGwApp.datosGenerales.label.segundoApellido"
                  ),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.apellidoMaterno,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.solicitante,
                        "apellidoMaterno",
                        $$v
                      )
                    },
                    expression: "solicitud.solicitante.apellidoMaterno",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.cvu"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.cvu,
                    callback: function ($$v) {
                      _vm.$set(_vm.solicitud.solicitante, "cvu", $$v)
                    },
                    expression: "solicitud.solicitante.cvu",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.solicitud"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.id,
                    callback: function ($$v) {
                      _vm.$set(_vm.solicitud, "id", $$v)
                    },
                    expression: "solicitud.id",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.edad"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.SOLICITUD_RIZOMA.solicitante.edad,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.solicitante,
                        "edad",
                        $$v
                      )
                    },
                    expression: "solicitud.SOLICITUD_RIZOMA.solicitante.edad",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t(
                    "apeironGwApp.datosGenerales.label.correoNotificacion"
                  ),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.correo,
                    callback: function ($$v) {
                      _vm.$set(_vm.solicitud.solicitante, "correo", $$v)
                    },
                    expression: "solicitud.solicitante.correo",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.rfc"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.solicitante.rfc,
                    callback: function ($$v) {
                      _vm.$set(_vm.solicitud.solicitante, "rfc", $$v)
                    },
                    expression: "solicitud.solicitante.rfc",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-form-group",
              { staticClass: "col-12", attrs: { disabled: "" } },
              [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    _vm._s(_vm.$t("apeironGwApp.datosGenerales.label.info"))
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.solicitud.SOLICITUD_RIZOMA.tipoBecaExtranjero ===
            "ESPECIALIDADES_MEDICAS_CUBA"
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "col-12",
                    attrs: {
                      label: _vm.$t(
                        "apeironGwApp.datosGenerales.label.tipoPostulacion"
                      ),
                      disabled: "",
                    },
                  },
                  [
                    _c("b-form-input", {
                      model: {
                        value:
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoSolicitud.nombre,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.solicitud.SOLICITUD_RIZOMA.tipoSolicitud,
                            "nombre",
                            $$v
                          )
                        },
                        expression:
                          "solicitud.SOLICITUD_RIZOMA.tipoSolicitud.nombre",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-12",
                attrs: {
                  label: _vm.$t(
                    "apeironGwApp.datosGenerales.label.institucion"
                  ),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.apoyo.institucion.nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.apoyo.institucion,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.apoyo.institucion.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.tipoApoyo"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo.nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.programa"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.SOLICITUD_RIZOMA.apoyo.programa,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.apoyo,
                        "programa",
                        $$v
                      )
                    },
                    expression: "solicitud.SOLICITUD_RIZOMA.apoyo.programa",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-4",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.pais"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value: _vm.solicitud.SOLICITUD_RIZOMA.apoyo.pais.nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.apoyo.pais,
                        "nombre",
                        $$v
                      )
                    },
                    expression: "solicitud.SOLICITUD_RIZOMA.apoyo.pais.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-6",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.area"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento.area
                        .nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento.area,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.areaConocimiento.area.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-6",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.campo"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento.campo
                        .nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento.campo,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.areaConocimiento.campo.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-6",
                attrs: {
                  label: _vm.$t("apeironGwApp.datosGenerales.label.disciplina"),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento.disciplina
                        .nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento
                          .disciplina,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.areaConocimiento.disciplina.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "col-6",
                attrs: {
                  label: _vm.$t(
                    "apeironGwApp.datosGenerales.label.subdisciplina"
                  ),
                  disabled: "",
                },
              },
              [
                _c("b-form-input", {
                  model: {
                    value:
                      _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento
                        .subdisciplina.nombre,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.solicitud.SOLICITUD_RIZOMA.areaConocimiento
                          .subdisciplina,
                        "nombre",
                        $$v
                      )
                    },
                    expression:
                      "solicitud.SOLICITUD_RIZOMA.areaConocimiento.subdisciplina.nombre",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            false
              ? _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("h4", { staticClass: "title mt-4 mb-4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("apeironGwApp.datosGenerales.label.montos")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-table", {
                      ref: "tableRubros",
                      staticClass: "table-conciliacion",
                      attrs: {
                        striped: "",
                        hover: "",
                        fields: _vm.fields,
                        items: _vm.solicitud.datos_conciliados.rubros,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell()",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.getNombreRubro(data.item.concepto)
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.conciliacionExtranjeras.rubros.anual"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(data.item.divisa) +
                                    "\n        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_1)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_1
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            keypress: _vm.numbersOnly,
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_1,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_1,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_1.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_1,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_1.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_2)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_2
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            keypress: _vm.numbersOnly,
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_2,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_2,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_2.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_2,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_2.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_3)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_3
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            keypress: _vm.numbersOnly,
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_3,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_3,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_3.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_3,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_3.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_4)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_4
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            keypress: _vm.numbersOnly,
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_4,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_4,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_4.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_4,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_4.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_5)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_5
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_5,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_5,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_5.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_5,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_5.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(anio_6)",
                            fn: function (data) {
                              return [
                                data.item.montos.anio_6
                                  ? _c(
                                      "b-input-group",
                                      { attrs: { prepend: "$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: { readonly: true },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateInput(
                                                data.item.montos.anio_6,
                                                "monto"
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.formatInput(
                                                data.item.montos.anio_6,
                                                "monto"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              data.item.montos.anio_6.monto,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item.montos.anio_6,
                                                "monto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.montos.anio_6.monto",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3267341333
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isValidador
              ? _c(
                  "b-form-group",
                  { staticClass: "col-12" },
                  [
                    _vm.solicitud.SOLICITUD_RIZOMA.documentoSolicitud.documento
                      .uri
                      ? _c(
                          "b-link",
                          {
                            attrs: {
                              href: _vm.solicitud.SOLICITUD_RIZOMA
                                .documentoSolicitud.documento.uri,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  id: "id-solicitudRizoma",
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.datosGenerales.label.solicitudRizoma"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon-descargar" }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.solicitud.anexo_uno
                      ? _c(
                          "b-link",
                          {
                            attrs: {
                              href: _vm.solicitud.anexo_uno,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button", id: "id-anexo" },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.datosGenerales.label.anexo"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon-descargar" }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.solicitud.urlConvenio
                      ? _c(
                          "b-link",
                          {
                            attrs: {
                              href: _vm.solicitud.urlConvenio,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button", id: "id-cab" },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.datosGenerales.label.convenio"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon-descargar" }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }